import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import * as React from 'react';
import classNames from 'classnames';
import { getCompProps } from '../_utils';
import { ConfigContext } from '../config-provider';
import Preview from './preview';
import PreviewGroup from './preview-group';

var ImageInternal = function ImageInternal(props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var allProps = getCompProps('Image', userDefaultProps, props);
  var innerRef = React.useRef();
  var previewRef = ref || innerRef;
  var id = allProps.id,
      alt = allProps.alt,
      name = allProps.name,
      size = allProps.size,
      width = allProps.width,
      height = allProps.height,
      preview = allProps.preview,
      fallback = allProps.fallback,
      operations = allProps.operations,
      _allProps$placeholder = allProps.placeholder,
      placeholder = _allProps$placeholder === void 0 ? '' : _allProps$placeholder,
      customPrefixcls = allProps.prefixCls; // className前缀

  var prefixCls = getPrefixCls(pkgPrefixCls, 'image', customPrefixcls);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      exit = _React$useState2[0],
      setExit = _React$useState2[1];

  React.useEffect(function () {
    if (exit) setVisible(true);
  }, [exit]);

  var _React$useState3 = React.useState(placeholder),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      src = _React$useState4[0],
      setSrc = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      error = _React$useState6[0],
      setError = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      visible = _React$useState8[0],
      setVisible = _React$useState8[1];

  var _React$useState9 = React.useState(''),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      transformOrigin = _React$useState10[0],
      setTransformOrigin = _React$useState10[1];

  React.useEffect(function () {
    placeholder && setSrc(placeholder);
    var img = new window.Image();
    img.src = props.src;

    img.onload = function () {
      setError(false);
      setSrc(props.src);
    };

    img.onerror = function () {
      setError(true);
      setSrc(fallback || props.src);
    };
  }, [props.src, fallback, placeholder]);
  var imgProps = {
    id: id,
    src: src,
    alt: alt,
    style: {
      height: height
    },
    className: "".concat(prefixCls, "-img")
  };

  if (!error) {
    imgProps.onClick = function (e) {
      preview && (exit ? setVisible(true) : setExit(true));
      props.onClick && props.onClick(e);
    };
  }

  var calcTransformOrigin = function calcTransformOrigin(element) {
    var _context;

    var transformOriginX = element.getBoundingClientRect().x + element.getBoundingClientRect().width / 2;
    var transformOriginY = element.getBoundingClientRect().y + element.getBoundingClientRect().height / 2;
    setTransformOrigin(_concatInstanceProperty(_context = "".concat(transformOriginX, "px ")).call(_context, transformOriginY, "px"));
  };

  React.useEffect(function () {
    previewRef.current && calcTransformOrigin(previewRef.current);
  });

  var onClose = function onClose() {
    return setVisible(false);
  };

  var previewProps = {
    alt: alt,
    name: name,
    size: size,
    visible: visible,
    src: props.src,
    type: props.previewType,
    style: _extends(_extends({}, props.previewStyle), {
      transformOrigin: transformOrigin
    }),
    className: props.previewClassName,
    operations: props.previewOperations,
    onClose: onClose
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, props.className, {
      error: error
    }),
    style: _extends({
      width: width,
      height: height
    }, props.style)
  }, /*#__PURE__*/React.createElement("img", _extends({}, imgProps, {
    ref: previewRef
  })), (operations === null || operations === void 0 ? void 0 : operations.length) > 0 && !error && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-action")
  }, operations), preview && exit && /*#__PURE__*/React.createElement(Preview, _extends({}, previewProps)));
};

var Image = /*#__PURE__*/React.forwardRef(ImageInternal);
var ImageOuter = Image;
ImageOuter.Preview = Preview;
ImageOuter.PreviewGroup = PreviewGroup;
ImageOuter.displayName = 'Image';
export default ImageOuter;